/* QubCommon Methods */
import { calculate } from "qubCommon/helperMethods/dateHelper";
import {
  wijmoAggregateColumns,
  wijmoCurrencyFormat,
  wijmoDateFormat,
} from "qubCommon/wijmoHelpers/columnMethods";
import { formatRequestObject } from "qubCommon/helperMethods/formatRequest";

/* Imports for Modal */
import { useModal, ModalImages, ModalButtons } from "context/modalContext";

/* API Calls */
import { authorizedGenApiCall } from "api/genApiCalls";

/* React, Redux, React-Hook-Forms */
import { useState, useRef, useEffect } from "react";
import { useSelector } from "react-redux";
import { format } from "date-fns";
import { useForm } from "react-hook-form";
import { useParams } from "react-router-dom";

/* Wijmo Imports */
import { CollectionView, PropertyGroupDescription } from "@grapecity/wijmo";
import { FlexGridXlsxConverter } from "@grapecity/wijmo.grid.xlsx";
import "./index.css";

const useAppointments = () => {
  /* react-hook forms */

  const { filterKey } = useParams();
  const form = useForm();
  const { reset, handleSubmit, formState } = form;
  const { isDirty } = formState;

  /* redux */
  const [gridData, setGridData] = useState(null);
  const [explParams, setExplParams] = useState([]);
  const [rowDialog, setRowDialog] = useState(false);
  const [rowData, setRowData] = useState(null);
  const { dateFormat } = useSelector((state) => state.auth);

  /* Refs */
  const gridRef = useRef();
  const toolbarRef = useRef();

  const { openModal } = useModal();

  const gridLoadedRows = (flex) => {
    flex.columns.forEach((c) => {
      console.log(c);
      if (c.binding === "LogId") c.visible = false;
      if (c.binding === "Comments") c.width = "*";
    });
  };

  const gridInitialized = (flex) => {
    gridRef.current = flex;
    flex.selectionMode = "Row";

    flex.hostElement.addEventListener("dblclick", (e) => {
      const ht = flex.hitTest(e.pageX, e.pageY);
      const view = ht?.grid?.collectionView;
      const currentItem = view?.currentItem;
      console.log(currentItem, "debugHere");
      if (flex.columns[ht.col]?.binding === "RequestDoc" && ht.cellType === 1) {
        setRowData({
          type: "requestJson",
          data: flex.getCellData(ht.row, ht.col),
        });
        setRowDialog(true);
      } else if (
        flex.columns[ht.col]?.binding === "ResponseDoc" &&
        ht.cellType === 1
      ) {
        setRowData({
          type: "responseJson",
          data: flex.getCellData(ht.row, ht.col),
        });
        setRowDialog(true);
      } else {
        const view = ht?.grid?.collectionView;
        const currentItem = view?.currentItem;
        if (currentItem && ht.cellType === 1) {
          setRowData({
            type: "rowObject",
            data: currentItem,
          });
          setRowDialog(true);
        }
      }
    });

    flex.hostElement.addEventListener("touchend", (e) => {
      const ht = flex.hitTest(e);
      const view = ht?.grid?.collectionView;
      const currentItem = view.currentItem;
      if (currentItem && ht.cellType === 1) {
      }
    });

    flex.hostElement.addEventListener("keydown", (e) => {
      const view = flex.collectionView;
      const currentItem = view.currentItem;
      if (e.code === "Enter" && view.currentItem) {
        e.preventDefault();
        e.stopPropagation();
        /* Runs handle select */
      }
    });
    // console.log("mpika init");

    flex.itemFormatter = (panel, r, c, cell) => {
      /* html + css for rowHeaders A/A */

      // });

      if (panel.cellType === 3) {
        cell.innerHTML = `<div class='row-header'> ${
          panel.rows[r]?.index + 1
        }</div>`;
      }

      // if (panel.rows[r]?.dataItem?.RecordMsg) {
      //   panel.rows[r].cssClass = "warning-message";
      // }
      /* date format */
      wijmoDateFormat(panel, r, c, cell, "RequestDate", true, {
        d: 0,
        m: 1,
        y: 2,
        format: "dd/MM/yyyy",
      });
      wijmoDateFormat(panel, r, c, cell, "ResponseDate", true, {
        d: 0,
        m: 1,
        y: 2,
        format: "dd/MM/yyyy",
      });
    };
    // flex.columnHeaders.rows[0].visible = false;
  };

  const onSubmit = async (data) => {
    reset(data);
    const res = await fetchData(data);
    let helpData = new CollectionView(res);
    setGridData(helpData);
    if (!helpData?.itemCount)
      openModal({
        title: "ΣΦΑΛΜΑ",
        message: `Δεν βρέθηκαν Εγγραφές`,
        imageType: ModalImages.Info,
        buttons: ModalButtons.OK,
        defaultButton: ModalButtons.OK,
        callback: () => {},
      });
  };

  const excelHandleClick = () => {
    FlexGridXlsxConverter.saveAsync(
      gridRef.current,
      {
        includeColumnHeaders: true,
        includeStyles: false,
      },
      "FlexGrid.xlsx"
    );
  };

  const fetchData = async (data) => {
    const formValues = formatRequestObject(data);

    const res = await authorizedGenApiCall({
      dataKey: "eShop-Logs-Expl",
      parameters: [...formValues],
    });
    try {
      const parsedData = JSON.parse(res?.data);
      return parsedData;
    } catch {
      console.log(res, "parsing-error");
    }
  };

  const createEpge = async (data) => {};

  const today = format(new Date(), "yyyy-MM-dd");
  const dateFrom = today + " 00:00";
  const dateTo = today + " 23:59";

  useEffect(() => {
    async function fetchParams() {
      const res = await authorizedGenApiCall({
        dataKey: "eShop-Logs-ExplParams",
      });
      try {
        const parsedData = JSON.parse(res?.data);
        setExplParams(parsedData);
        console.log(parsedData);
      } catch {
        console.log(res, "parsing-error");
      }
    }
    fetchParams();
  }, []);

  useEffect(() => {
    if (isDirty || filterKey) setGridData({ items: [] });
  }, [isDirty, filterKey]);

  return {
    gridInitialized,
    handleSubmit,
    toolbarRef,
    gridLoadedRows,
    gridRef,
    onSubmit,
    excelHandleClick,
    fetchData,
    createEpge,
    form,
    isDirty,
    gridData,
    explParams,
    filterKey,
    rowData,
    rowDialog,
    setRowData,
    setRowDialog,
  };
};

export default useAppointments;
